import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

let _cache = null;
let _subs = new Set();

async function _refresh() {
  try {
    const { data } = await api.get("/feature-flags");
    _cache = data || {};
    _subs.forEach((fn) => fn(_cache));
  } catch {
    _cache = _cache || {};
  }
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState(_cache);
  useEffect(() => {
    _subs.add(setFlags);
    if (_cache == null) _refresh();
    else setFlags(_cache);
    return () => { _subs.delete(setFlags); };
  }, []);
  return { flags: flags || {}, refresh: _refresh };
}

export function useFeatureFlag(key) {
  const { flags } = useFeatureFlags();
  return !!flags[key];
}
